import { render } from "./News05.vue?vue&type=template&id=510e2701&scoped=true"
import script from "./News05.vue?vue&type=script&lang=js"
export * from "./News05.vue?vue&type=script&lang=js"

import "./News05.vue?vue&type=style&index=0&id=510e2701&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-510e2701"]])

export default __exports__